import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
//import { useTranslation } from "react-i18next";
import { Card, CardBody } from 'reactstrap';
import Footer from '../../Components/Footer';
import NavBar from '../../Components/NavBar';
import BreadCrumb from '../../Components/BreadCrumb';
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import { useTranslation } from "react-i18next";

export default function _NoSesssionPage({ children, title }) {

    document.title = title;
    const { t } = useTranslation();



    React.useMemo(() => {
        if ((sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') || true) {
            let currentSession = sessionStorage.getItem("currentSession");
            axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
            axios.defaults.headers.common["Authorization"] = currentSession !== null ? JSON.parse(currentSession)?.bearerToken : null;
            let ApiGateway = process.env.REACT_APP_API_URL;

        }
    }, [t]);

    return (
        <React.Fragment>
            <ToastContainer />
            <Container fluid="l">
                {
                    <>
                        {children && children}
                    </>
                }
            </Container>
        </React.Fragment>
    )

}